import { useIntl } from 'react-intl';
import { useConfig } from '~/core/configuration/configContext';
import { ChunkType } from './settings';

type UseResultsCountMessage = {
    productCurrentCount: number;
    productTotalCount: number;
};

const customMessage = ({
    message,
    productCurrentCount,
    productTotalCount,
}: {
    message: string;
    productCurrentCount: number;
    productTotalCount: number;
}) => {
    return `${message
        .replace('{currentCount}', productCurrentCount.toString())
        .replace('{totalCount}', productTotalCount.toString())}`;
};

export const useResultsCountMessage = ({ productCurrentCount, productTotalCount }: UseResultsCountMessage) => {
    const intl = useIntl();
    const {
        translations: { results_count },
    } = useConfig();

    const resultsCountMessage = (() => {
        // --- MESSAGE USING PLURAL INTERPOLATION ---
        // The problem is that on some sites, there is a situation where format JS interpolation is not working due to collision with other scripts like MicrosoftAjax.js
        // viz. https://jira.mediafactory.cz/browse/SRSERP-244
        // the workaround is to catch the error in the component and then use custom fallback solution
        let message = '';
        try {
            message = intl.formatMessage(
                {
                    id: 'results_count',
                    defaultMessage: 'Zobrazujeme <strong>{currentCount} ze {totalCount}</strong> nalezených produktů.',
                },
                {
                    currentCount: productCurrentCount,
                    totalCount: productTotalCount,
                    strong: (chunks: ChunkType) => `<strong>${chunks}</strong>`,
                }
            );
        } catch (error) {
            console.warn(`Fallback message formatting for message id: "results_count".`);
            try {
                message = customMessage({ message: results_count, productCurrentCount, productTotalCount });
            } catch (err: unknown) {
                console.warn(
                    `Fallback message formatting for message id: "results_count" failed. Using static message.`
                );
                console.error(err);
                return `Zobrazujeme <strong>${productCurrentCount} ze ${productTotalCount}</strong> nalezených produktů.`;
            }
        }
        return message;
    })();
    return resultsCountMessage;
};
